import React from 'react'
import {Button} from "reactstrap";

const DeleteModal=({deleteMedia,setIsDeleteModalVisible})=> {
    
    return (
    <div>
        <p >Do you want to delete</p>
        <div style={{display:'flex',flexDirection:'row'}}>
        <Button color='info' onClick={deleteMedia}>Yes</Button>
        <Button  onClick={()=>setIsDeleteModalVisible(false)}>No</Button>
        </div>
    </div>
    )
}

export default DeleteModal